exports.incomeTypes = [
  { type: "D", label: "Disability" },
  { type: "S", label: "Social Security" },
  { type: "U", label: "Unemployed" },
  { type: "P", label: "Pension" },
  { type: "O", label: "Other" }
];

exports.payFrequencies = [
  { type: "W", label: "Weekly" },
  { type: "B", label: "Bi-Weekly" },
  { type: "S", label: "Semi-Monthly" },
  { type: "M", label: "Monthly" }
];

exports.loanPurposes = [
  { id: "Debt Consolidation" },
  { id: "Home Improvement" },
  { id: "Medical Expenses" },
  { id: "Household Expenses" },
  { id: "Large Purchase" },
  { id: "Vacation" },
  { id: "Auto" },
  { id: "Taxes" },
  { id: "Business" },
  { id: "Other" }
];

exports.paymentMethods = [
  { type: "D", label: "Direct Deposit" },
  { type: "P", label: "Paper Check" },
  { type: "C", label: "Cash" }
];

exports.identificationTypes = [
  { id: "Driver's License", label: "Driver's License" },
  { id: "Driver's License", label: "Passport" },
];

exports.employmentTypes = [
  { id: "employed", label: "Employed" },
  { id: "self_employed", label: "Self Employed" },
  { id: "other_income", label: "Other Income" },
];

exports.bankAccountTypes = [
  { id: "C", label: "Checking" },
  { id: "S", label: "Saving" },
];

exports.loanPurposesAtlas = [
  { id: "Household Expenses", label: "Bills / Household Expenses" },
  { id: "Debt Consolidation", label: "Debt Consolidation" },
  { id: "Medical Expenses", label: "Medical Expenses" },
  { id: "Home Improvement", label: "Home Renovations" },
  { id: "Large Purchase", label: "Major Purchase" },
  { id: "Other", label: "Other" }
];

exports.atlasDateRange = [
  { id: "less-3", label: "Less than 3 months" },
  { id: "3-6", label: "3-6 months" },
  { id: "7-12", label: "7-12 months" },
  { id: "13-24", label: "13-24 months" },
  { id: "24-48", label: "24-48 months" },
  { id: "49+", label: "49 months +" },
];
